import { withRouter } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { connect } from "react-redux";
import { useState, useEffect, useRef } from 'react';
import NetworkTable, { ColumnConfig, ColumnType, NetworkTableRow } from '../../components/InterfacesTable/NetworkTable/NetworkTable';
import { Box, Container } from '@mui/material';
import FilterSearchAddBar from '../../components/FilterSearchAddBar/FilterSearchAddBar';
import { getWifiInterfacesData, deleteWifiData, updateWanInterfaceData, addWanInterfaceData, getPhysicalInterfacesData, getFilteredNetworksData, getDeviceLinkStatusData } from '../../../../../actions/Users/authenticateOpenEdgeService';
import { DELETE_WIFI, ADD_WAN_INTERFACE, UPDATE_WAN_INTERFACE } from '../../../../../actions/types';
import AddEditInterfaceModal from "../../components/Modals/AddEditInterfaceModal";
import LabelValueDisplay from "../../components/LabelValue/LabelValueDisplay";
import _ from "lodash";
import DeleteWANProfileModal from "../../components/Modals/DeleteProfileModal";
import CustomLoader from "../../../../../components/Loader/CustomLoader";
import TabsComponent from "../../../../../components/NewTabs";
import ToggleWithLabel from '../../components/ToggleWithLabel/ToggleWithLabel';
import { useConfigAutoRefresh } from "../../hooks/useConfigAutoRefresh";
import { isVersionLessThanEqual } from "../../../../../utils/util";

// Wi-Fi Band became editable on an existing interface starting with build v2.2.0.0;
// on older builds it stays read-only on edit, as before.
const WIFI_BAND_EDITABLE_MIN_VERSION = "v2.2.0.0";

const WiFiTab = (props) => {
  const { getWifiInterfacesData, getWifiInterfaces, selectedRow, deleteWifiData, deleteWifi, updateWanInterfaceData, addWanInterfaceData, addWanInterface, updateWanInterface, getFilteredNetworksData, getFilteredNetworks,
    getWifiInterfacesLoading, getFilteredNetworksLoading, addWanInterfaceLoading, updateWanInterfaceLoading, deleteWIFILoading, deviceInfo, getDeviceLinkStatusData, getDeviceLinkStatus, refreshIconClicked, setRefreshIconClicked, deviceLinkStatusLoading, notifyConfigAction, notifyConfigActionComplete } = props;
  const dispatch = useDispatch()
  const isHubSupported = !['T101', 'T102', 'T103', 'T104'].includes(selectedRow?.tierValue);
  const isWifiBandEditable = !!selectedRow?.['current_EOS_version']
    && isVersionLessThanEqual(WIFI_BAND_EDITABLE_MIN_VERSION, selectedRow['current_EOS_version']);

  const [wifiData, setWifiData] = useState<NetworkTableRow[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [vidError, setVidError] = useState("");
  const [formData, setFormData] = useState<any>({ ssid: '', name: '' });
  const [isEditPopup, setIsEditPopup] = useState(false);
  // const [physicalInterfaces, setPhysicalInterfaces] = useState<any>([]);
  const [row, setRow] = useState<any>({});
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [lanNetworks, setLanNetworks] = useState<any>([]);
  const [aliasError, setAliasError] = useState('');
  const [passwordError, setPasswordError] = useState("");
  const [ssidError, setSsidError] = useState('');
  const [columns, setColumns] = useState<ColumnConfig[]>([
    {
      label: "SSID",
      key: "ssid",
      type: ColumnType.textWithImage,
      maxWidth: "180px",
    },
    {
      label: "LAN Name",
      key: "network",
      type: ColumnType.text,
      maxWidth: "102px",
    },
    {
      label: "Wi-Fi Band",
      key: "device",
      type: ColumnType.conditional,
      maxWidth: "72px",
    },
    {
      label: "Channel",
      key: "test",
      type: ColumnType.text,
      maxWidth: "72px",
    },
    {
      label: "Mode",
      key: "mode",
      type: ColumnType.conditional,
      maxWidth: "109px",
    },
    // {
    //   label: "Clients",
    //   key: "test",
    //   type: ColumnType.text,
    //   maxWidth: "63px",
    // },
    {
      label: "Security",
      key: "security",
      type: ColumnType.text,
      maxWidth: "102px",
    },
    {
      label: "Actions",
      key: "custom",
      type: ColumnType.actions,
      actions: ["setting", "delete"],
      maxWidth: "82px",
    }
  ])
  const [activeTab, setActiveTab] = useState('wifi');

  useEffect(() => {
    if (deviceInfo === 'ap') {
      const updatedColumns = columns.filter(col => col.label !== 'Actions');
      setColumns(updatedColumns);
    }
  }, [deviceInfo])

  // Skip the very first firing (tab mount) of the interfaces-status call:
  // InventoryPopup's centralized effect already refreshes it once when this
  // tab opens, so this only needs to react to an actual manual refresh click.
  const skipFirstLinkStatusFetchRef = useRef(true);
  useEffect(() => {
    if(refreshIconClicked) {
      getWifiInterfacesData(selectedRow['deviceId']);
      if (skipFirstLinkStatusFetchRef.current) {
        skipFirstLinkStatusFetchRef.current = false;
      } else {
        getDeviceLinkStatusData(selectedRow['k4Id'], selectedRow['deviceId']);
      }
    }
  }, [refreshIconClicked])

  // Same calls the manual refresh button triggers, but on a 30s idle baseline
  // (immediate on mount/tab switch too), sped up to 2s during an in-flight
  // config change via startAction()/stopAction() below. Interfaces status
  // itself is refreshed centrally (InventoryPopup), not duplicated here.
  const wifiAutoRefresh = useConfigAutoRefresh({
    fetchFns: [
      (silent) => getWifiInterfacesData(selectedRow['deviceId'], silent),
    ],
    enabled: !!selectedRow?.deviceId,
  });

  useEffect(() => {
    if (isModalOpen) {
      // getPhysicalInterfacesData(selectedRow['deviceId']);
      getFilteredNetworksData(selectedRow['deviceId']);
    }
  }, [isModalOpen])

  useEffect(() => {
    if (!_.isEmpty(getWifiInterfaces)) {
      const rawData = getWifiInterfaces?.wifiinterfaces || [];

      const transformed = rawData.map(item => ({
        ...item,
        device: item?.primary_interface == "WIFI_ALL" ?  '2.4GHz,5GHz' :item.device === 'radio1' ? '5GHz' : '2.4GHz',
        mode: item.mode === 'sta' ? 'WAN WI-FI' : 'Access Point'
      }));

      const statusList = getDeviceLinkStatus && getDeviceLinkStatus.hasOwnProperty('result') ? getDeviceLinkStatus?.result?.data : [];
      // success === false is a real, backend-confirmed "couldn't sync with the
      // device" response (not a swallowed client-side network error, which is
      // already filtered out before this state is ever set) - treat every
      // interface as down rather than unknown/grey.
      const linkStatusSyncFailed = getDeviceLinkStatus?.success === false;
      const updated = transformed?.map((item) => {
        const matches = statusList?.filter((s) => s.ssid === item.ssid);
        let color;

        if (matches && matches.length > 0) {
          const anyLinkUp = matches.some((m) => m.link_up);
          color = anyLinkUp ? 'GREEN' : 'RED';
        } else {
          color = linkStatusSyncFailed ? 'RED' : 'GREY';
        }

        return { ...item, color };
      });

      setWifiData(updated);
      // setRefreshIconClicked(false);
    }
    if (!_.isEmpty(getFilteredNetworks)) {
      const data = getFilteredNetworks && getFilteredNetworks.hasOwnProperty('status') && getFilteredNetworks.status ? getFilteredNetworks.access_networks : [];
      setLanNetworks(data);
    }
  }, [getWifiInterfaces, getFilteredNetworks, getDeviceLinkStatus])

  const handleActionClick = (
    type: "setting" | "refresh" | "delete" | "portal" | "edit",
    headerKey: string,
    row: NetworkTableRow
  ) => {
    console.log(`Action "${type}" clicked on ${headerKey}`, row);
    switch (type) {
      case "delete":
        setIsDeleteModalOpen(true);
        setRow(row);
        break;
     case "setting":
  const selectedNetwork = lanNetworks.find(n => n.network_alias === row['network']);
  const isCaptive = selectedNetwork?.isCaptive;

  setIsModalOpen(true);
  setIsEditPopup(true);
  setFormData({
    device: row?.primary_interface == 'WIFI_ALL' ? 'WIFI_ALL' :row['device'] === '5GHz' ? 'WIFI_5' : 'WIFI_2.4',
    ssid: row['ssid'],
    password: row['key'],
    mode: row['mode'],
    name: row['alias'],
    id: row['id'],
    network: row['network'],
    security: row['security'] == 'WPA2/WPA3' ? 'WPA2/WPA3' : 'Open',
    hub_enabled: row['hub_enabled'] ?? false,
    // forceSecurityOpen: isCaptive || false,
  });
  break;
      default:
        console.warn(`Unhandled action type: ${type}`);
    }
  };

  useEffect(() => {
    if (!_.isEmpty(deleteWifi) || !_.isEmpty(addWanInterface) || !_.isEmpty(updateWanInterface)) {
      wifiAutoRefresh.stopAction();
      notifyConfigActionComplete?.();
    }
    if (!_.isEmpty(deleteWifi) && deleteWifi?.status == true) {
      getWifiInterfacesData(selectedRow['deviceId']);
      dispatch({ type: DELETE_WIFI, payload: {} })
      setIsDeleteModalOpen(false);
    }
    if (!_.isEmpty(addWanInterface) && addWanInterface?.status == true) {
      getWifiInterfacesData(selectedRow['deviceId']);
      dispatch({ type: ADD_WAN_INTERFACE, payload: {} });
      setIsModalOpen(false);
      setFormData({});
    }
    if (!_.isEmpty(updateWanInterface) && updateWanInterface?.status == true) {
      getWifiInterfacesData(selectedRow['deviceId']);
      dispatch({ type: UPDATE_WAN_INTERFACE, payload: {} })
      setIsEditPopup(false);
      setIsModalOpen(false);
      setFormData({});
    }
  }, [deleteWifi, addWanInterface, updateWanInterface])

  const validatePassword = (value, mode) => {
    if (value === "") {
      setPasswordError("");
      return;
    }

    if (mode === "WAN WI-FI") {
      setPasswordError("");
    } else if (mode === "Access Point") {
      if (value.length < 8) {
        setPasswordError("Password must be at least 8 characters.");
      } else if (value.length > 32) {
        setPasswordError("Password cannot exceed 32 characters.");
      } else {
        setPasswordError("");
      }
    }
  };

  const handleChange = (key: string) => (e: any) => {
  const value = e.target.value;

    if (key == "mode") {
      setFormData((prev) => ({
        ...prev,
        device: ''
      }));

      // Re-validate password when mode changes
      if (formData.password) {
        validatePassword(formData.password, value);
      }
    }

  if (key === "ssid") {
    if (value === "") {
      setSsidError("");
    } else if (!/^[a-zA-Z0-9\-_\. ]+$/.test(value)) {
      setSsidError("Only letters, numbers, -, _, ., spaces allowed");
    } else {
      setSsidError("");
    }
    setFormData((prev) => ({
      ...prev,
      ssid: value,
      name: value,
    }));
    return;
  }

//   if (key === "network") {
//   const selectedNetwork = lanNetworks.find(n => n.network_alias === value);
//   const isCaptive = selectedNetwork?.isCaptive;

//   setFormData((prev) => ({
//     ...prev,
//     network: value,
//     security: isCaptive ? "Open" : "", 
//     forceSecurityOpen: isCaptive || false,
//   }));
//   return;
// }

  setFormData((prev) => ({ ...prev, [key]: value }));

  if (key === "security") {
    if (value === "Open") {
      setFormData((prev) => ({
        ...prev,
        security: value,
        password: "",
      }));
    } else {
      setFormData((prev) => ({ ...prev, security: value }));
    }
    return;
  }

  if (key === "password") {
    validatePassword(value, formData.mode);
  }
};


  const handleAddInterface = () => {
    const selectedNetwork = lanNetworks.find(network => network.network_alias === formData.network);

    const payload = {
      data: {
        action: isEditPopup ? 'update' : 'create',
        DID: selectedRow['deviceId'],
        device: formData.device === 'WIFI_5' ? 'radio1' : 'radio0',
        ssid: formData.ssid,
        key: formData?.security == 'WPA2/WPA3' ? formData.password : '',
        mode: formData.mode == 'Access Point' ? 'ap' : 'sta',
        is_primary: "0",
        primary_interface: formData.device,
        alias: formData.name,
        network: formData?.mode == 'Access Point' ? formData.network : undefined,
        network_id: formData?.mode == 'Access Point' ? selectedNetwork.id : undefined,
        network_vlan_id: formData?.mode == 'Access Point' ? selectedNetwork.vlan_id : undefined,
        ...(isEditPopup && { id: formData?.id }),
        ...(isHubSupported && formData?.mode !== 'Access Point' && { hub_enabled: !!formData?.hub_enabled }),
      }
    }
    wifiAutoRefresh.startAction();
    notifyConfigAction?.();
    isEditPopup ? updateWanInterfaceData(payload, 'processWifiInterface') : addWanInterfaceData(payload, 'processWifiInterface');
  };

  const handleClosePopup = () => {
    setIsModalOpen(false);
    setIsEditPopup(false);
    setFormData({});
    setSsidError('');
    dispatch({ type: ADD_WAN_INTERFACE, payload: {} });
    dispatch({ type: UPDATE_WAN_INTERFACE, payload: {} });
  }

  const isWifiFormValid = (): boolean => {
    if (!formData) return false;
    const { name, device, ssid, password, mode, network, security } = formData;
    if (!name?.trim() || !device || !ssid?.trim() || !mode || !security) {
      return false;
    }
    if (mode === "Access Point") {
      if (!network?.trim()) {
        return false;
      }
    }
    if (security === "WPA2/WPA3") {
      if (!password?.trim()) {
        return false;
      }
    }
    if (aliasError || ssidError) {
      return false;
    }
    if (passwordError) {
      return false;
    }
    return true;
  };

  const tabs = [
    { tabName: 'WiFi', tabValue: 'wifi', pathName: '/inventory' }
  ];

  const doNavigateTab = (pathname, tabName) => {
    setActiveTab(tabName);
  }

  return (
    <div className="tab-content internalPadding">
      <TabsComponent tabs={tabs} handleChangeTab={doNavigateTab} activeTab={activeTab} isSubTabs={true} removemarginTop={true} />
      <Container maxWidth="xl" className="app-container">
        <Box my={0}>
          <NetworkTable
            data={wifiData}
            columns={columns}
            showFilterBar
            addButtonLabel="Add Wifi Interface"
            onAddClick={() => setIsModalOpen(true)}
            onActionClick={handleActionClick}
            deviceInfo={deviceInfo}
          />
        </Box>
        {getWifiInterfacesLoading || getFilteredNetworksLoading || addWanInterfaceLoading || updateWanInterfaceLoading || deleteWIFILoading|| deviceLinkStatusLoading ? (
          <CustomLoader
            showLoader={true}
            loadingText={"Please wait..."}
          />
        ) : null}
      </Container>

      <AddEditInterfaceModal
        open={isModalOpen}
        onClose={handleClosePopup}
        onSave={handleAddInterface}
        saveText={isEditPopup ? 'Update' : 'Add'}
        disableSave={!isWifiFormValid()}
        title={isEditPopup ? 'Edit Wifi' : 'Add Wifi'}
        layout={[
          {
            columns: [
              {
                component: (
                  <LabelValueDisplay
                    label="SSID"
                    isInput
                    value={formData?.ssid}
                    onChange={handleChange("ssid")}
                    placeholder="Enter SSID"
                    error={ssidError}
                  />
                ),
                gridSize: 6,
              },
              {
                component: (
                  <LabelValueDisplay
                    label="Name"
                    isInput
                    value={formData?.name}
                    onChange={handleChange("name")}
                    placeholder="Enter name"
                    error={aliasError}
                  />
                ),
                gridSize: 6,
              },
            ],
          },
          {
            columns: [
              {
                component: (
                  <LabelValueDisplay
                    label="Mode"
                    isDropdown
                    value={formData?.mode}
                    dropdownOptions={["WAN WI-FI", "Access Point"]}
                    onChange={handleChange("mode")}
                    placeholder="Select Mode"
                    disabled={isEditPopup}
                  />
                ),
                gridSize: 6,
              },
              {
                component: (
                  <LabelValueDisplay
                    label="LAN Network"
                    isDropdown
                    dropdownOptions={lanNetworks?.map(network => network.network_alias)}
                    value={formData?.network}
                    onChange={handleChange("network")}
                    placeholder="Select Network"
                    disabled={isEditPopup || formData?.mode !== 'Access Point'}
                  />
                ),
                gridSize: 6,
              },
            ],
          },
          {
            columns: [
              {
                component: (
                  <LabelValueDisplay
                    label="WI-FI Band"
                    isDropdown
                    value={formData?.device}
                    dropdownOptions={formData?.mode == 'Access Point' ? ["WIFI_ALL","WIFI_2.4","WIFI_5"] : ["WIFI_2.4","WIFI_5"]}
                    onChange={handleChange("device")}
                    placeholder="Select Band"
                    disabled={isEditPopup && !isWifiBandEditable}
                    infoText={isEditPopup && isWifiBandEditable ? "Changing band will interrupt internet traffic." : ""}
                  />
                ),
                gridSize: 6,
              },

            ],
          },
          {
            columns: [
              {
                component: (
                  <Box height="21px" />
                ),
                gridSize: 12,
              }
            ]
          },
          {
            columns: [
              {
  component: (
    <LabelValueDisplay
      label="Security"
      isDropdown
      value={formData?.security}
      dropdownOptions={["WPA2/WPA3", "Open"]}
      onChange={handleChange("security")}
      placeholder="Select Security"
      disabled={formData?.forceSecurityOpen}
    />
  ),
  gridSize: 6,
},
{
  component: (
    <LabelValueDisplay
      label="Password"
      isInput
      value={formData?.password}
      onChange={handleChange("password")}
      placeholder="Enter Password"
      disabled={formData?.security !== 'WPA2/WPA3'}
      error={passwordError}
      infoText={
        formData?.security === 'WPA2/WPA3'
          ? 'Password must be at least 8 characters.'
          : ''
      }
    />
  ),
  gridSize: 6,
}

            ],
          },
          ...(formData?.mode === "WAN WI-FI" && isHubSupported
            ? [
              {
                columns: [
                  {
                    component: (
                      <ToggleWithLabel
                        label="Hub Dropoff"
                        checked={!!formData?.hub_enabled}
                        onChange={(val) => setFormData((prev) => ({ ...prev, hub_enabled: val }))}
                      />
                    ),
                    gridSize: 12,
                  },
                ],
              },
            ]
            : []),
          {
            columns: [
              {
                component: (
                  <span style={{ color: "red", fontSize: "12px" }}>
                    {!_.isEmpty(updateWanInterface) && updateWanInterface.msg}
                  </span>
                ),
                gridSize: 12,
              }
            ],
          },
          {
            columns: [
              {
                component: (
                  <span style={{ color: "red", fontSize: "12px" }}>
                    {!_.isEmpty(addWanInterface) && addWanInterface.msg}
                  </span>
                ),
                gridSize: 12,
              },
            ],
          },
        ]}
      />
      {row.alias && (
        <DeleteWANProfileModal
          open={isDeleteModalOpen}
          onClose={() => {setIsDeleteModalOpen(false); dispatch({type: DELETE_WIFI, payload: {}})}}
          onConfirm={() => {
            wifiAutoRefresh.startAction();
            notifyConfigAction?.();
            deleteWifiData(selectedRow['deviceId'], row['id']);
          }}
          profileName={row.alias}
          errorMessage={deleteWifi?.status == false && deleteWifi?.msg ? deleteWifi?.msg : ''}
        />
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  getWifiInterfaces: state.authReducer.getWifiInterfaces,
  deleteWifi: state.authReducer.deleteWifi,
  addWanInterface: state.authReducer.addWanInterface,
  updateWanInterface: state.authReducer.updateWanInterface,
  // getPhysicalInterfaces: state.authReducer.getPhysicalInterfaces,
  getFilteredNetworks: state.authReducer.getFilteredNetworks,
  getWifiInterfacesLoading: state.authReducer.getWifiInterfacesLoading,
  getFilteredNetworksLoading: state.authReducer.getFilteredNetworksLoading,
  addWanInterfaceLoading: state.authReducer.addWanInterfaceLoading,
  updateWanInterfaceLoading: state.authReducer.updateWanInterfaceLoading,
  deleteWIFILoading: state.authReducer.deleteWIFILoading,
  getDeviceLinkStatus: state.authReducer.getDeviceLinkStatus,
  deviceLinkStatusLoading: state.authReducer.getDeviceLinkStatusLoading,
});

export default withRouter(
  connect(mapStateToProps, { getWifiInterfacesData, deleteWifiData, updateWanInterfaceData, addWanInterfaceData, getFilteredNetworksData, getDeviceLinkStatusData })(WiFiTab)
)